import { Http } from '../Utils/Http';
import { AxiosResponse } from 'axios';
import { IObraDetailsUpdate } from './interfaces/Obra/IObraDetails';
import {
  IObraDisciplinesRequest,
  IObraDisciplinesResponse,
} from './interfaces/Obra/IObraDisciplines';
import {
  IObraInvitedUsersDeleteRequest,
  IObraInvitedUsersRequest,
  IObraUsersRequest, IObraInvitedUsersResponse, IObraUsersResponse,
} from './interfaces/Obra/IObraUsers';
import { IObraPermissionsRequest } from './interfaces/Obra/IObraPermissions';
import { IObraNomenclaturesRequest } from './interfaces/Obra/IObraNomenclaturas';
import {
  ICreateStageRequest,
  IDeleteStageRequest,
  IListStagesResponse,
  IOrderStageRequest,
  ISettingsStageRequest,
  IStage,
  IUpdateStageRequest,
  ICreateStageAxiosResponse,
} from './interfaces/Obra/IObraStages';
import {
  IConstructionSiteStageLibraryRequest,
  IConstructionSiteStageLibraryResponse,
} from './interfaces/Obra/IObraLibraries';
import { INomenclatureDataAxiosResponse } from './interfaces/Nomenclatura/INomenclatureData';
import { IUserData } from './interfaces/User/IUserData';

export class ObrasApiV2 {
         static async updateDetails(
           constructionSiteId: number,
           request: IObraDetailsUpdate,
         ): Promise<AxiosResponse<null>> {
           const axios = await Http.axios();
           return axios.put(
             `/v2/construction-sites/${constructionSiteId}/details`,
             request,
           );
         }

         static async updateDisciplines(
           request: IObraDisciplinesRequest,
         ): Promise<AxiosResponse<IObraDisciplinesResponse>> {
           const axios = await Http.axios();
           return axios.put(
             `/v2/construction-sites/${request.constructionStieId}/disciplines`,
             request.disciplines,
           );
         }

         static async listUsers(
           constructionSiteId: number,
         ): Promise<AxiosResponse<IUserData[]>> {
           const axios = await Http.axios();
           return axios.post(`/v2/construction-sites/${constructionSiteId}/users`);
         }

         static async updateUsers(
           request: IObraUsersRequest,
         ): Promise<AxiosResponse<IObraUsersResponse>> {
           const axios = await Http.axios();
           return axios.post(
             `/v2/construction-sites/${request.constructionStieId}/users`,
             { userId: request.userId },
           );
         }

         static async deleteUsers(
           request: IObraUsersRequest,
         ): Promise<AxiosResponse<void>> {
           const axios = await Http.axios();
           return axios.delete(
             `/v2/construction-sites/${request.constructionStieId}/users/${request.userId}`,
           );
         }

         static async updateInvitedUsers(
           request: IObraInvitedUsersRequest,
         ): Promise<AxiosResponse<IObraInvitedUsersResponse>> {
           const axios = await Http.axios();
           return axios.post(
             `/v2/construction-sites/${request.constructionStieId}/invited-users`,
             { email: request.email, roleId: request.roleId },
           );
         }

         static async deleteInvitedUsers(
           request: IObraInvitedUsersDeleteRequest,
         ): Promise<AxiosResponse<void>> {
           const axios = await Http.axios();
           return axios.delete(
             `/v2/construction-sites/${request.constructionStieId}/invited-users/${request.invitedEmail}`,
           );
         }

         static async updatePermissions(
           request: IObraPermissionsRequest,
         ): Promise<AxiosResponse<void>> {
           const axios = await Http.axios();
           return axios.put(
             `/v2/construction-sites/${request.constructionStieId}/permissions`,
             request.permissions,
           );
         }

         static async updateNomenclatures(
           request: IObraNomenclaturesRequest,
         ): Promise<AxiosResponse<INomenclatureDataAxiosResponse>> {
           const axios = await Http.axios();
           return axios.put(
             `/v2/construction-sites/${request.constructionStieId}/nomenclatures`,
             request.nomenclatures,
           );
         }

         static async listStages(
           csId: number,
         ): Promise<AxiosResponse<IListStagesResponse>> {
           const axios = await Http.axios();
           return axios.get(`/v2/construction-sites/${csId}/stages`);
         }

         static async createStages(
           request: ICreateStageRequest,
         ): Promise<AxiosResponse<ICreateStageAxiosResponse>> {
           const axios = await Http.axios();
           return axios.post(
             `/v2/construction-sites/${request.constructionStieId}/stages`,
             request.stage,
           );
         }

         static async updateStages(
           request: IUpdateStageRequest,
         ): Promise<AxiosResponse<ICreateStageAxiosResponse>> {
           const axios = await Http.axios();
           return axios.put(
             `/v2/construction-sites/${request.constructionStieId}/stages/${request.stageId}`,
             request.stage,
           );
         }

         static async orderStages(
           request: IOrderStageRequest,
         ): Promise<AxiosResponse<void>> {
           const axios = await Http.axios();
           return axios.put(
             `/v2/construction-sites/${request.constructionStieId}/stages/reorder`,
             request.stagesForRequest,
           );
         }

         static async deleteStages(
           request: IDeleteStageRequest,
         ): Promise<AxiosResponse<void>> {
           const axios = await Http.axios();
           return axios.delete(
             `/v2/construction-sites/${request.constructionStieId}/stages/${request.stageId}`,
           );
         }

         static async listLibraries(): Promise<
           AxiosResponse<IConstructionSiteStageLibraryResponse>
         > {
           const axios = await Http.axios();
           return axios.get('/v2/construction-sites/stage-libraries');
         }

         static async importLibrary(
           request: IConstructionSiteStageLibraryRequest,
         ): Promise<AxiosResponse<IStage[]>> {
           const axios = await Http.axios();
           return axios.post('/v2/construction-sites/stage/import', request);
         }

         static async settingsStages(
           request: ISettingsStageRequest,
         ): Promise<AxiosResponse<void>> {
           const axios = await Http.axios();
           return axios.put(
             `/v2/construction-sites/${request.constructionStieId}/stage-settings`,
             request.config,
           );
         }
       }
